import { useState, useEffect } from 'react';

export const breakpoints = {
  sm: '(max-width: 768px)', // Small devices (phones)
  md: '(max-width: 1024px)', // Medium devices (tablets)
  lg: '(min-width: 1025px)', // Large devices (desktops)
};

const useMediaQuery = (query: keyof typeof breakpoints | string): boolean => {
  const mediaQuery = typeof query === 'string' ? query : breakpoints[query];

  const [matches, setMatches] = useState(
    () =>
      typeof window !== 'undefined' && window.matchMedia(mediaQuery).matches,
  );

  useEffect(() => {
    const mediaQueryList = window.matchMedia(mediaQuery);
    const handleChange = () => setMatches(mediaQueryList.matches);

    mediaQueryList.addEventListener('change', handleChange);

    return () => mediaQueryList.removeEventListener('change', handleChange);
  }, [mediaQuery]);

  return matches;
};

export default useMediaQuery;

export const isMobile = (): boolean => {
  return (
    typeof window !== 'undefined' && window.matchMedia(breakpoints.sm).matches
  );
};

export function useIsMobileView() {
  return useMediaQuery(breakpoints.sm);
}
